import { useEffect, useState } from "react";
import { toastSuccess } from "../../../../../components/base/Toast";
import Form from "../../../../../components/form/Form";
import { getUser, useHub, usePreferences } from "../../../../../core/Global";
import Icon from "../../../../../components/base/Icon";
import ToggleSwitch from "../../../../../components/form/ToggleSwitch";
import { TechsPreferencesModel } from "../../../../../models/AccountPreferences";



export default function TechsSettings() {

    const hub = useHub();
    const user = getUser();
    const pref = usePreferences();
    const [working, workingSet] = useState<boolean>(false);

    const [body, bodySet] = useState<TechsPreferencesModel>({});

    useEffect(() => {
        if (pref) bodySet(pref.techsPreferences);
    }, [pref])



    return (
        <Form className="form"
            onSubmit={(e, callback) => {
                workingSet(true);
                hub.Post("/system/Settings/techpreferences", body, res => {
                    if (res.success) {
                        toastSuccess("Technician preferences has been updated successfully!");
                    }
                    if (callback) callback(res);
                    workingSet(false);
                });
            }}>
            <div className="card mb-5">
                <div className="card-header border-0">
                    <div className="card-title m-0">
                        <h3 className="fw-bolder m-0">
                            Technicians Settings
                        </h3>
                    </div>
                    <div className="card-action">
                        <button type="submit" className="btn btn-sm btn-primary" disabled={working}>
                            {
                                working ?
                                    <>
                                        <Icon icon="spinner-third" spin />
                                        <span className="ms-2">Updating...</span>
                                    </>
                                    : <>Update Preferences</>
                            }
                        </button>
                    </div>
                </div>
                <div className="card-body border-top px-9 pt-10 pb-4">

                    <ToggleSwitch label="Allow technicians to create new jobs via mobile app!"
                        name="allowTechsToCreateJob" raw small className="mb-5"
                        checked={body.allowTechsToCreateJob}
                        onChange={e => bodySet({
                            ...body,
                            allowTechsToCreateJob: e
                        })} />

                    <ToggleSwitch label="Allow technicians to close jobs pending agent approval!"
                        name="allowTechsToCloseJobPending" raw small className="mb-5"
                        checked={body.allowTechsToCloseJobPending}
                        onChange={e => bodySet({
                            ...body,
                            allowTechsToCloseJobPending: e,
                            allowTechsToCloseJobDirectly: false
                        })} />

                    <ToggleSwitch label="Allow technicians to close jobs directly using default rates!"
                        name="allowTechsToCloseJobDirectly" raw small className="mb-5"
                        checked={body.allowTechsToCloseJobDirectly}
                        onChange={e => bodySet({
                            ...body,
                            allowTechsToCloseJobDirectly: e,
                            allowTechsToCloseJobPending: false
                        })} />

                    <ToggleSwitch label="Allow technicians to create and send job invoices!"
                        name="allowTechsToCreateJobInvoice" raw small className="mb-5"
                        checked={body.allowTechsToCreateJobInvoice}
                        onChange={e => bodySet({
                            ...body,
                            allowTechsToCreateJobInvoice: e
                        })} />


                </div>
            </div>
        </Form>
    )
}